import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  courses: [],
  iCalFile: {},
  streams: [],
  coursePlanningStream: {},
  lastUpdatedTime: {}
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/semester/vuex/index.js